import { i18next } from '@vmos2/core';
import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const isPhone = (countryCode: string, value: string) => {
  const number = value && value.length > 3 && phoneUtil.parseAndKeepRawInput((+value).toString().trim(), countryCode);

  return !value || (number && phoneUtil.isValidNumberForRegion(number, countryCode))
    ? undefined
    : i18next.t('validations:invalidMobilePhone');
};
